export enum LazoFileType {
  FILE_REQUEST_TASK = "FILE_REQUEST_TASK",
  DOCUMENT_REVIEW = "DOCUMENT_REVIEW",

  // DEPRECATED, use REQUEST_INFORMATION_TASK
  REQUEST_LEGAL_INCORPORATION_TASK = "REQUEST_LEGAL_INCORPORATION_TASK",
  REQUEST_PID_INFORMATION_TASK = "REQUEST_PID_INFORMATION_TASK",
  REQUEST_BOI_INFORMATION_TASK = "REQUEST_BOI_INFORMATION_TASK",
  // -- END DEPRECATION NOTICE --

  PRODUCT_FLOW_DELIVERABLE = "PRODUCT_FLOW_DELIVERABLE",
  FUNDER_IMAGE = "FUNDER_IMAGE",
  FILE_THUMBNAIL = "FILE_THUMBNAIL",
  REQUEST_INFORMATION_TASK = "REQUEST_INFORMATION_TASK",

  // ONLY FOR TESTING
  TEST_FILE = "TEST_FILE",
}
